module.exports = __webpack_public_path__ + "static/bob-iger-b1201f1fc5dacd4459f6fad5ee98488f.jpg";